import { createEngagement } from '@services/youtube-platform.service';
import { character } from '@components/RunOfShow/defaultSelectionData';
export const handleEngagement = async ({ streamId, platformType, currentRosFeature, interactionId = null }) => {
  const startTime = Date.now();
  const sessionId = localStorage.getItem('sessionId');

  let payload = {
    interactionId,
    startTime,
    title: currentRosFeature.title,
    platformType,
    questionId: currentRosFeature.id,
    brandColours: currentRosFeature.color,
    settings: currentRosFeature.setting,
    sessionId
  };

  if (currentRosFeature.options) {
    payload = { ...payload, options: currentRosFeature.options };
  }

  if (currentRosFeature.type) {
    payload = { ...payload, type: currentRosFeature.type };
  }

  return await createEngagement(streamId, currentRosFeature.type, payload);
};

export const getOptionsName = (currentRosFeature, number) => {
  if (currentRosFeature.type !== 'pollWithOptions') {
    return number + 1;
  }

  if (currentRosFeature.setting.OptionsList === 'character') {
    return character(number);
  }

  return number + 1;
};

export const mapContinents = [
  {
    name: 'World', value: 'world', zoom: 1.5, coordinates: [29, 9.88]
  },
  {
    name: 'Asia', value: 'asia', zoom: 2.5, coordinates: [110.878, 40.854]
  },
  {
    name: 'Africa', value: 'africa', zoom: 2.8, coordinates: [24.459, -2.079]
  },
  {
    name: 'Australia', value: 'australia', zoom: 3.5, coordinates: [132.689, -24.196]
  },
  {
    name: 'Europe', value: 'europe', zoom: 3, coordinates: [20.087, 52.975]
  },
  {
    name: 'North America', value: 'north-america', zoom: 2.8, coordinates: [-106.203, 52.494]
  },
  {
    name: 'South America', value: 'south-america', zoom: 2.8, coordinates: [-58.123, -25.491]
  }
];

export const parseColorToRgba = (color, alpha = 1) => {
  if (!color) return `rgba(0, 0, 0, ${alpha})`;

  // Extract the last rgb or rgba value from the string (useful for gradients)
  const rgbaMatches = color.match(/rgba?\([\d\s.,]+\)/gi);
  if (rgbaMatches && rgbaMatches.length > 0) {
    const lastRgba = rgbaMatches[rgbaMatches.length - 1];
    const values = lastRgba.match(/[\d.]+/g);

    if (values && values.length >= 3) {
      const [r, g, b] = values;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }

  color = color.replace(/^#/, '');

  let r, g, b;
  if (color.length === 3) {
    r = parseInt(color[0] + color[0], 16);
    g = parseInt(color[1] + color[1], 16);
    b = parseInt(color[2] + color[2], 16);
  } else if (color.length === 6) {
    r = parseInt(color.substring(0, 2), 16);
    g = parseInt(color.substring(2, 4), 16);
    b = parseInt(color.substring(4, 6), 16);
  } else {
    return `rgba(0, 0, 0, ${alpha})`;
  }

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const mapSoundOptions = [
  { name: 'Pop', value: 'pop' },
  { name: 'Chime', value: 'chime' },
];

export const talkingTileSoundOptions = [
  { name: 'Whoosh', value: 'whoosh' },
  { name: 'Chime', value: 'chime' },
];

export const wheelSpinSoundOptions = [
  { name: 'Glass', value: 'glass' },
  { name: 'Tick', value: 'tick' },
];

export const wheelButtonSoundOptions = [
  { name: 'Button', value: 'button' },
  { name: 'Knob-button', value: 'knob-button' },
];

export const wheelResultSoundOptions = [
  { name: 'Fanfare', value: 'fanfare' },
  { name: 'Applause', value: 'applause' },
];

export const soundUrls = {
  pop: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/stories_sounds_pop-on.mp3',
  chime: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/stories_sounds_chime-on.mp3',
  whoosh: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/stories_sounds_whoosh-on.mp3'
};

export const featureSoundUrls = {
  map: {
    pop: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/stories_sounds_pop-on.mp3',
    chime: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/stories_sounds_chime-on.mp3'
  },
  talkingTiles: {
    whoosh: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/whoosh-talking-tile.mp3',
    brick_fall: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/brick-fall-talking-tiles.mp4'
  },
  wheelSpin: {
    glass: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/glass.mp3',
    tick: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/tick.mp3',
  },
  wheelButton: {
    button: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/button.mp3',
    knob_button: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/knob-button.mp3',
  },
  wheelResult: {
    fanfare: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/fanfare.mp3',
    applause: process.env.NEXT_PUBLIC_BUCKET_URL + 'Sounds/applause.mp3',
  }
};
